import { HTTP_STATUSES } from "@miplatform/constants";
import { useBids } from "@mibuildweb/hooks";
import { CreateBidPayload } from "./CreateBids.types";

export const useCreateBidViewModel = ({
  reset = () => null,
}: UseCreateBidViewModelProps = {}) => {
  const { isLoading, bidDetails, getBidDetails, updateBid } = useBids();

  const fetchBidDetails = async (bidId: string) => {
    const response = await getBidDetails(bidId);
    if (response.status === HTTP_STATUSES.OK) {
      reset(response.data);
    }
  };

  const handleCreateBid = async (data: CreateBidPayload) => {
    const response = await updateBid(data);
    if (response.status === HTTP_STATUSES.OK) {
      fetchBidDetails(response.data.id);
    }
  };

  return {
    isLoading,
    bidDetails,
    fetchBidDetails,
    handleCreateBid,
  };
};

interface UseCreateBidViewModelProps {
  reset?: (data: CreateBidPayload) => void;
}
